import { UserSessionModel } from '@/db/models';
import type { AppUserSettingData, OrderSettings } from '@/api/models/OrderSettings';
import { UserSessionDB } from '@/db/repositories';
import { IPublicClientApplication } from '@azure/msal-browser';
import { clearGwApiAccessTokenCache } from '@/auth/GatewayApiAccessToken';

// Sign out from MSAL
export const signOut = async (instance: IPublicClientApplication) => {
  const account = instance.getActiveAccount() || instance.getAllAccounts()[0] || undefined;
  const logoutRequest = {
    account,
    postLogoutRedirectUri: import.meta.env.TOURPWA_MSAL_LOGOUT_URI || '/',
  };
  //instance.logoutRedirect(logoutRequest);
  try {
    await instance.logoutPopup(logoutRequest);
    return true;
  } finally {
    clearGwApiAccessTokenCache();
  }
};

export const isSessionExpired = (userSession: UserSessionModel) => {
  const expiry = 1000 * 60 * 60 * 72; // 72 hours = 3 days
  let isExpired = false;
  if (userSession) {
    const age = Date.now() - new Date(userSession.timestamp).getTime();
    isExpired = age > expiry;
  }
  return isExpired;
};

export const getUser = async () => {
  const user = await UserSessionDB.load();
  return user;
};

export const setUser = async (user: UserSessionModel) => {
  await UserSessionDB.save(user);
};

export const updateOrderSettings = async (appUserId: number, key: keyof OrderSettings, data: AppUserSettingData): Promise<void> => {
  const user = await getUser();
  if (user?.appUserId !== appUserId) throw new Error('Your session changed. Reopen Settings to continue.');
  user.orderSettings = { ...user.orderSettings, [key]: { ...user.orderSettings?.[key], ...data } };
  await setUser(user);
};

export const getToken = async () => {
  const user = await UserSessionDB.load();
  return user?.token;
};

export const clearSession = async () => {
  await UserSessionDB.clear();
  clearGwApiAccessTokenCache();
};
